import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import NavbarComp from '../components/NavbarComp'
import FooterComp from '../components/FooterComp'
import { Container } from 'react-bootstrap'
import { CorrectIcon, WrongIcon } from '../assets/images'
import { Correct, Wrong } from '../assets/media'
import { storeQuestions, baselineTestAnswers } from "../hooks/baseline"
import { useNavigate } from 'react-router-dom'

const mapStateToProps = (state) => {
  return {
    baseline: state.baseline,
    auth: state.auth
  }
}
const mapDispatchToProps = dispatch => ({
  storeQuestions: (baseline, step) => dispatch(storeQuestions(baseline, step)),
  baselineTestAnswers: (data, step) => dispatch(baselineTestAnswers(data, step))
});

const getLable = (time) => {
  switch (time) {
    case 3:
      return "READY"
    case 2:
      return "READY SET"
    case 1:
      return "READY SET GO"
    case 0:
      return "BASELINE TEST "
    default:
      break;
  }
}
const generateRandomPattern = ()=>{
  
  const wordOption = ["Yellow", "Blue", "Yellow", "Blue", "Yellow", "Blue", "Yellow", "Blue"];
  const colourOption = ["Blue", "Yellow", "Blue", "Yellow", "Blue", "Yellow", "Blue", "Yellow"];
    let pattern = [];
    for (let i = 0; i < 2; i++) {
      const randomOption = { word: wordOption[Math.floor(Math.random() * wordOption.length)], color: colourOption[Math.floor(Math.random() * colourOption.length)] };
      pattern.push({ ...randomOption });
    }
    return pattern;
} 

const generateTestCase = () => {
  let parentArray = [];
  while (parentArray.length < 2) {
    let newPattern = generateRandomPattern();
    if (!parentArray.some(pattern => JSON.stringify(pattern) === JSON.stringify(newPattern))) {
      parentArray.push(newPattern);
    }
  }
  return parentArray;
}

const getTimeDifferent = (start, now) => {
  const t1 = start;
  const t2 = now;
  const diffInMs = Math.abs(t2 - t1)
  return diffInMs
}

const avgResponseTime = (data) => {
  var avTime = 0
  var totTime = 0

  for (let i = 0; i < data.length; i++) {
    totTime = totTime + data[i]
  }

  if (totTime !== 0) {
    avTime = totTime / data.length
  }

  return avTime
}

const getBarWidth = (total, start, type) => {
  var bar = 0
  var count = 0
  if (!(start > total || start === total)) {
    count = 60 - start
    bar = (count / total) * 100 
    count = String(count).padStart(2, "0")
  } 
  
  switch (type) {
    case "time":
      return count
    case "percentage":
      return bar + "%"
  
    default:
      break;
  }
}

const NavigateOnStateChange = ({ shouldNavigate, to }) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (shouldNavigate) {
      navigate(to);
    }
  }, [shouldNavigate, navigate, to]);

  return null;
};

class AlertnessTest extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      timeLeft: 3,
      test: 0,
      test_result: null,
      questions: generateTestCase(),
      answers: [],
      answered: false,
      start_time: null,
      answer_time: [],
      next_click: null,
      step: 1,
      lable_show: true,
      timeLeftCount: 63,
      scoreCalculate: false,
      shouldNavigate: false,
      path: null
    };

  }
  startTimer = () => {
    this.timerSixty = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.timeLeftCount > 0) {
          return { timeLeftCount: prevState.timeLeftCount - 1 };
        } else {
          this.stopTimer(); 
          return { timeLeftCount: 0 };
        }
      }, () => this.calculateScore());
    }, 1000);
  };

  calculateScore = () => {
    if(this.state.timeLeftCount == 0) {
      if (this.props.auth.baseline && !this.state.scoreCalculate) {
        this.props.baselineTestAnswers({
          baseline: 0,
          company_id: 0,
          user_id: this.props.auth.user !== null ? this.props.auth.user.id : 0,
          start_time_1: this.state.start_time,
          end_time_1: Date.now(),
          avg_response_time_1: avgResponseTime(this.state.answer_time),
          answers_1: this.state.answers,
          json_text_1: {
            "start_time": this.state.start_time,
            "end_time": Date.now(),
            "responed_time": this.state.answer_time,
            "answers": this.state.answers
          }
        }, this.props.baseline.step)
        this.setState({ scoreCalculate: true })
      }
      if(this.props.auth.baseline) {return false}
        
      if (this.props.baseline.step === 1) {
        this.props.storeQuestions({
          start_time: this.state.start_time,
          end_time: Date.now(),
          avg_response_time: avgResponseTime(this.state.answer_time),
          answers: this.state.answers,
          json_text: {
            "start_time": this.state.start_time,
            "end_time": Date.now(),
            "responed_time": this.state.answer_time,
            "answers": this.state.answers
          }
        }, 2)
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.setState({
            shouldNavigate: true,
            path: "/alertness-test-complete"
          })
        }, 1500)
      } else if (this.state.timeLeftCount == 0 && !this.state.scoreCalculate && this.state.step === 2) {
        this.props.baselineTestAnswers({
          company_id: 0,
          baseline: 1,
          user_id: this.props.auth.user !== null ? this.props.auth.user.id : 0,
  
          start_time_1: this.props.baseline.test.start_time,
          end_time_1: this.props.baseline.test.end_time,
          avg_response_time_1: this.props.baseline.test.avg_response_time,
          answers_1: this.props.baseline.test.answers,
          json_text_1: this.props.baseline.test.json_text,
  
          start_time_2: this.state.start_time,
          end_time_2: Date.now(),
          avg_response_time_2: avgResponseTime(this.state.answer_time),
          answers_2: this.state.answers,
          json_text_2: {
            "start_time": this.state.start_time,
            "end_time": Date.now(),
            "responed_time": this.state.answer_time,
            "answers": this.state.answers
          }
        }, this.props.baseline.step)
        this.setState({ lable_show: false, scoreCalculate: true })
      }
    }
  }

  stopTimer = () => {
    clearInterval(this.timerSixty);
  };

  componentDidUpdate() {
    if (this.props.baseline.score != null) {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.setState({
          shouldNavigate: true,
          path: "/alertness-test-result"
        })
      }, 500)
    }
  }

  componentDidMount() {
    this.startCountdown()
    this.startTimer();
    if (this.props.baseline.step !== this.state.step) {
      this.setState({
        step: this.props.baseline.step
      })
    }
  }

  componentWillUnmount() {
    this.clearCountdown();
  }

  startCountdown = () => {
    this.interval = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.timeLeft > 0) {
          return { timeLeft: prevState.timeLeft - 1 }
        } else {
          this.setState({
            start_time: Date.now(),
            next_click: new Date()
          })
          this.clearCountdown()
          return { timeLeft: 0 }
        }
      });
    }, 1000)
  }

  clearCountdown = () => {
    clearInterval(this.interval);
  };

  handleAnswer = (event) => {
    const cAudio = new Audio(Correct);
    const wAudio = new Audio(Wrong);
    if (event.target.value === "true") {
      cAudio.play()
    } else {
      wAudio.play()
    }

    this.state.answers.push(event.target.value === "true" ? true : false)
    this.setState({
      test_result: event.target.value === "true" ? 1 : 0,
      answered: true
    })
    this.state.answer_time.push(getTimeDifferent(this.state.next_click, new Date()))
    // if (this.state.test === this.state.questions.length - 1) {

      
    //   return false
    // }

    clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.setState({
        test_result: null,
        answered: false,
        next_click: new Date()
      }, () => {
        let newPattern = generateRandomPattern();
        var questionCopy = this.state.questions
        // if (!questionCopy.some(pattern => JSON.stringify(pattern) === JSON.stringify(newPattern))) {
          questionCopy.push(newPattern);
          this.setState({ questions: questionCopy, test: this.state.test + 1 })
        // }
      })
    }, 100)
  }

  render() {
    return <Fragment>

      <NavbarComp access_token={true}/>
      <div className="page-sections">
        <div className='alertness-test-wrap'>
          <Container>
            <div className='alertness-test-contents'>
              <h2 className='main-title-style'>
                {this.props.auth.baseline && this.state.lable_show ? "DAILY ALERTNESS" : <>
                  {getLable(this.state.timeLeft)}
                  {this.state.timeLeft === 0 ? this.state.step + " of 2" : null}</>}
              </h2>
              {this.state.timeLeft !== 0 ?
                <div className='alertness-test-box'>
                  <span className='count-down'>{this.state.timeLeft}</span>
                </div> :
                <div className='alertness-test-box'>
                  {this.state.test_result === 1 ? <img src={CorrectIcon} alt="Correct Icon" /> : null}
                  {this.state.test_result === 0 ? <img src={WrongIcon} alt="Wrong Icon" /> : null}
                    <div className='alertness-bar'><span style={{ width: getBarWidth(60, this.state.timeLeftCount,"percentage") }}><p>{getBarWidth(60, this.state.timeLeftCount,"time")} s</p></span></div>
                  <span style={{ color: this.state.questions[this.state.test][0].color === "Blue" ? "#5EAAAF" : "#F2B644" }} className='alertness-color-text yellow-text'>
                    {this.state.questions[this.state.test][0].word}
                  </span>

                  <div className='alertness-test-btns'>
                    <button disabled={this.state.answered || this.state.timeLeftCount === 0} value={this.state.questions[this.state.test][0].color === this.state.questions[this.state.test][1].word} onClick={this.handleAnswer} style={{ color: this.state.questions[this.state.test][1].color === "Blue" ? "#5EAAAF" : "#F2B644" }}>
                      {this.state.questions[this.state.test][1].word}
                    </button>
                    <button disabled={this.state.answered || this.state.timeLeftCount === 0} value={this.state.questions[this.state.test][0].color !== this.state.questions[this.state.test][1].word} onClick={this.handleAnswer} style={{ color: this.state.questions[this.state.test][1].color === "Blue" ? "#F2B644" : "#5EAAAF" }}>
                      {this.state.questions[this.state.test][1].word === "Yellow" ? "BLUE" : "Yellow"}
                    </button>
                  </div>
                </div>}
            </div>
          </Container>
        </div>
      </div>
      <FooterComp />
      <NavigateOnStateChange shouldNavigate={this.state.shouldNavigate} to={this.state.path} />
    </Fragment>
  }
}

AlertnessTest.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(AlertnessTest);
